var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          async = _props.async,
          creatable = _props.creatable,
          searchable = _props.searchable,
          label = _props.label,
          props = _objectWithoutProperties(_props, ['async', 'creatable', 'searchable', 'label']);

      var SelectClass = void 0;
      if (async) {
        SelectClass = creatable ? ReactSelect.AsyncCreatable : ReactSelect.Async;
      } else {
        SelectClass = creatable ? ReactSelect.Creatable : ReactSelect;
      }

      return React.createElement(
        'div',
        { className: 'cf-select' },
        label && React.createElement(
          'label',
          null,
          label
        ),
        React.createElement(SelectClass, _extends({}, props, {
          searchable: searchable,
          clearable: searchable || creatable,
          backspaceRemoves: searchable || creatable
        }))
      );
    }
  }]);

  return Select;
}(React.Component);

Select.defaultProps = {
  multi: false,
  searchable: false,
  async: false,
  creatable: false
};

export default Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-select/es/Select.js
// module id = 697
// module chunks = 0